import {
  FormControl,
  FormControlLabel,
  FormControlLabelProps,
  FormLabel,
  Radio,
  RadioGroup,
  RadioGroupProps,
  RadioProps,
} from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';

type IRadioButtonElement = Omit<
  FormControlLabelProps,
  'control' | 'key' | 'value'
> & {
  label: string;
  value: string;
};

type IRadioButtonRHFProps = RadioGroupProps & {
  className?: string;
  /** Label affiché au-dessus du groupe */
  label?: string;
  /** Nom du champ RHF (obligatoire) */
  name: string;
  /** Liste des éléments du groupe de radio */
  radioElements: IRadioButtonElement[];
  /** Props appliquées au composant Radio */
  radioProps?: RadioProps;
};

function RadioButtonRHF({
  label,
  name,
  row,
  className,
  radioElements,
  radioProps,
}: IRadioButtonRHFProps) {
  const { control } = useFormContext();

  return (
    <FormControl component="fieldset" className={className}>
      {label && <FormLabel component="legend">{label}</FormLabel>}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <RadioGroup aria-label={label} row={row} {...field}>
            {radioElements.map((elt) => (
              <FormControlLabel
                {...elt}
                key={elt.value}
                control={<Radio {...radioProps} />}
              />
            ))}
          </RadioGroup>
        )}
      />
    </FormControl>
  );
}

export default RadioButtonRHF;
